import { Component, OnInit, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { HttpClient, HttpClientModule, HttpParams } from '@angular/common/http';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatPaginator, MatPaginatorModule, PageEvent } from '@angular/material/paginator';
import { MatCardModule } from '@angular/material/card';
import { MatFormField, MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { environment } from '../../environments/environment';
import { HeaderComponent } from "../header/header.component";
import { FooterComponent } from "../footer/footer.component";
import { MatSort, Sort } from '@angular/material/sort';
import { MatOption } from "@angular/material/core";
import { MatSelect, MatSelectModule } from '@angular/material/select';
import { MatSortModule } from '@angular/material/sort';
// O se sei in un componente standalone (Angular 15+):
import { provideAnimations } from '@angular/platform-browser/animations';
import { Router } from '@angular/router';
import { MatProgressSpinner } from "@angular/material/progress-spinner";

@Component({
  selector: 'app-anagrafiche-professionisti',
  standalone: true,
  imports: [
    CommonModule, ReactiveFormsModule, HttpClientModule,
    MatTableModule, MatPaginatorModule, MatCardModule,
    MatFormFieldModule, MatInputModule, MatButtonModule, MatIconModule,
    HeaderComponent,
    FooterComponent,
    MatOption,
    MatSelectModule,
    MatSelect,
    MatFormField,
    MatSortModule,
    MatProgressSpinner
  ],
  templateUrl: './anagrafiche-professionisti.component.html',
  providers: [
    provideAnimations(), // <--- Fondamentale per far apparire le frecce
    // ... gli altri tuoi provider (OAuth, HttpClient, etc.)
  ],
  styleUrl: './anagrafiche-professionisti.component.css'
})
export class AnagraficheProfessionistiComponent implements OnInit {

  @ViewChild(MatSort) sort!: MatSort; // <--- AGGIUNGI QUESTO
  // Endpoint centralizzato salvato in precedenza
  API_ENDPOINT_COT_SERVICE = environment.API_ENDPOINT_COT_SERVICE;

  loading = false;

  formRicerca: FormGroup;
  dataSource = new MatTableDataSource<any>([]);
  displayedColumns: string[] = ['id', 'nominativo', 'codiceFiscale', 'strutture', 'qualifiche'];

  listaQualifiche: Qualifica[] = []; // Array per popolare la dropdown
  listaStrutture: Struttura[] = []; // Nuova lista per le strutture

  // Paginazione
  pageSize = 10;
  pageElements = 0;
  pageIndex = 0;

  // Parametri di ordinamento
  currentOrder: string = 'asc';
  currentColonna: string = 'id';

  constructor(private fb: FormBuilder, private http: HttpClient, private router: Router) {
    this.formRicerca = new FormGroup({
      codiceQualifiche: new FormControl<string[]>([]), // Multicheck qualifiche (da referente_operatore_ruolo)
      idStruttura: new FormControl(''),
      testoRicerca: new FormControl('')
    });
  }

  ngAfterViewInit() {
    // Questo serve a far apparire le frecce nel template
    this.dataSource.sort = this.sort;
  }

  ngOnInit() {
    this.caricaQualifiche();
    this.caricaStrutture();
    this.getOperatori();
  }

  caricaQualifiche() {
    this.http.get<Qualifica[]>(this.API_ENDPOINT_COT_SERVICE + `/qualifiche`).subscribe({
      next: (res) => {
        this.listaQualifiche = [...res].sort((a, b) => (a.descrizione ?? '').localeCompare(b.descrizione ?? '', 'it'));
      },
      error: (err) => console.error("Errore nel caricamento qualifiche", err)
    });
  }

  caricaStrutture() {
    this.http.get<Struttura[]>(this.API_ENDPOINT_COT_SERVICE + `/strutture`).subscribe({
      next: (res) => {
        this.listaStrutture = [...res].sort((a, b) => (a.denominazione ?? '').localeCompare(b.denominazione ?? '', 'it'));
      },
      error: (err) => console.error("Errore caricamento strutture", err)
    });
  }

  getOperatori() {
    this.loading = true;
    const { codiceQualifiche, idStruttura, testoRicerca } = this.formRicerca.value;

    const url = this.API_ENDPOINT_COT_SERVICE + `/operatori-page`;

    let params = new HttpParams()
      .set('pageNumber', this.pageIndex.toString())
      .set('pageSize', this.pageSize.toString())
      .set('order', this.currentOrder)
      .set('colonna', this.currentColonna);
    if (codiceQualifiche?.length) {
      codiceQualifiche.forEach((c: string) => { params = params.append('qualifica', c); });
    }
    if (idStruttura) params = params.set('idStruttura', String(idStruttura));
    if (testoRicerca) params = params.set('ricercaLibera', testoRicerca);

    this.http.get<PageResponse<Operatore>>(url, { params }).subscribe({
      next: (res) => {
        this.dataSource.data = res.content;
        this.pageElements = res.totalElements;
        this.loading = false;
      }
    });
  }

  // Gestisce il click sulle testate della tabella
  handleSortEvent(sort: Sort) {
    // sort.active corrisponde al matColumnDef (es: 'nominativo')
    // sort.direction corrisponde a 'asc', 'desc' o ''

    if (!sort.active || sort.direction === '') {
      this.currentColonna = 'id';
      this.currentOrder = 'asc';
    } else {
      this.currentColonna = sort.active;
      this.currentOrder = sort.direction;
    }

    this.pageIndex = 0; // Torna sempre alla prima pagina quando cambi ordine
    this.getOperatori();
  }

  onSubmit() {
    this.pageIndex = 0; // Reset alla prima pagina su nuova ricerca
    this.getOperatori();
  }

  pulisciForm() {
    this.formRicerca.reset({
      codiceQualifiche: [],
      idStruttura: '',
      testoRicerca: ''
    });
    this.pageIndex = 0;
    this.getOperatori();
  }

  handlePageEvent(e: PageEvent) {
    this.pageIndex = e.pageIndex;
    this.pageSize = e.pageSize;
    this.getOperatori(); // Ricarica i dati per la nuova pagina
  }

  onFilterChange() {
    this.pageIndex = 0; // Reset della pagina al primo risultato
    this.getOperatori();
  }

  cerca() {
    this.pageIndex = 0;
    this.getOperatori();
  }

  vaiAlDettaglio(id: number) {
    this.router.navigate(['/operatore-dettaglio', id]);
  }

}

export interface Qualifica {
  id: number;
  codice: string;
  descrizione: string;
}

export interface Struttura {
  id: number;
  codice: string;
  denominazione: string;
  codTipologiaStruttura?: string | null;
}

export interface Operatore {
  id: number;
  nome: string;
  cognome: string;
  codiceFiscale: string;
  codice?: string; // Corrisponde al campo 'codice' visto nel tuo JSON
  qualifiche: Qualifica[]; // Array di oggetti convertiti
  strutture: Struttura[] | null; // Oggetto Struttura o null se non assegnato
  dataDiNascita?: string | null;
  email?: string | null;
  numeroCellulare?: string | null;
}

export interface PageResponse<T> {
  content: T[];
  totalElements: number;
  totalPages: number;
  size: number;
  number: number;
}